import React, { JSX } from 'react';
import { AccordionTab } from '../../../../Accordion/src/AccordionTab';
import { Accordion } from '../../../../Accordion/src/Accordion';

/**
 * This component is used within the `HeaderParentItem` if the nav items should be display within an overlay.
 * @memberof Internal-Component
 */
export const ParentItemAccordion = ({
  id,
  className,
  labelVisual,
  children,
  href,
  onClick,
  ...rest
}: any): JSX.Element => {
  return (
    <li id={id} className={className} {...rest}>
      <Accordion as="div" noBorderTop hasFullWidthContent>
        <AccordionTab labelVisual={labelVisual} href={href} onClick={onClick}>
          {children}
        </AccordionTab>
      </Accordion>
    </li>
  );
};
